import { useState, useEffect } from "react";
import { Box, InputBase, Typography, Button } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseSupplierRequest } from "./UseSupplierRequest";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function SupplierRequests() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getRequestList, cancelAllRequest } = UseSupplierRequest();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Shamsidate", "desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [supplierRes, setRequestRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getRequestList(
      myPc,
      search,
      (supplierrequest) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(supplierrequest.pageCondition.totalPage);
          return;
        }
        setRequestRes(supplierrequest);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/supplierrequest/addRequest", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "operator",
      headerName: "اوپراتور",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.operator ? cellValues.row.operator : "-"}
          </Typography>
        );
      },
    },
    {
      field: "productID",
      headerName: "کد محصول",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productID}
          </Typography>
        );
      },
    },

    {
      field: "product",
      headerName: "محصول",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.product}
          </Typography>
        );
      },
    },
    {
      field: "requestCount",
      headerName: "تعداد",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.requestCount
              ? toMoney(cellValues.row.requestCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "shamsidate",
      headerName: "تاریخ درخواست",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.shamsidate}
          </Typography>
        );
      },
    },
    {
      field: "shamsiExpiredate",
      headerName: "تاریخ انقضا",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.shamsiExpiredate}
          </Typography>
        );
      },
    },

    {
      field: "isEnable",
      headerName: "فعال",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isEnable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 150,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => {
                setScrollTo(cellValues.api.getScrollPosition());
                return navigate("/supplierrequest/editRequest", {
                  state: {
                    model: cellValues.row,
                    myPc: myPc,
                    search: search,
                    id: cellValues.row.id,
                  },
                });
              }}
            >
              جزئیات
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: cellValues.row.product,
                  id: cellValues.row.id,
                });
              }}
            >
              لغو
            </Button>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [{ name: msActiveMenu.pageTitle, url: "/supplierrequest" }],
      }}
    >
      {supplierRes ? (
        <DataGrid
          disableVirtualization
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={supplierRes.pageCondition.pageCount}
          rows={supplierRes.items}
          paginationMode="server"
          page={supplierRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={supplierRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: supplierRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"همه درخواست های محصول"}
        callback={() => {
          setProgress(true);
          cancelAllRequest(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
